<template>
  <div>
       <a-tabs v-model="time_type" @change="callback">
            
            <a-tab-pane key="perDay" tab="某日统计">
            </a-tab-pane>
            <a-tab-pane key="perHour" tab="某时统计">
            </a-tab-pane>
        </a-tabs>

        <div class="searchBox">

            <label for="">选择日期：</label>

            <a-date-picker   @change="onChange" v-model="current_time" />
            
            <a-time-picker v-model="current_time" v-if="time_type != 'perDay'" :format="current_format" style="margin-left:10px;" />

            <label class="serviceLabel" for="">服务提供方：</label>
            <!-- <a-select style="width: 120px" v-model="selectedAppcode" show-search>
                <a-select-option v-for="(item,index) in appcodes" :key="index" :value="item">
                    {{item}}
                </a-select-option>
            </a-select> -->
            <AppAutoComplete  @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>

            <label class="serviceLabel" for="">服务消费方：</label>
            <!-- <a-select style="width: 120px" v-model="selectedInvokeappcode" show-search>
                <a-select-option v-for="(item,index) in appcodes" :key="index" :value="item">
                    {{item}}
                </a-select-option>
            </a-select> -->
            <AppAutoComplete  @onAppCodeChange="handleInvokAppcodeChange"></AppAutoComplete>

            
        </div>

        <div class="searchBox">
            <label for="">服务&方法:</label>
            <historySelecter style="width:590px;margin-left:10px;" @onUrlCodeChange="handleUrlChange"></historySelecter>
            <a-button class="searchItem" style="margin-left:10px;" type="primary" @click="handleSubmit">查询</a-button>

        </div>
  </div>
</template>
<script>
import moment from 'moment';
import historySelecter from './historyurlselecter'
import AppAutoComplete from '@/components/AppAutoComplete'
const oneDayLong = 24 * 60 * 60 * 1000;
const oneMinitLong = 60 * 1000;
export default {
    data() {
        return {
            time_type:'perDay',
            current_format:'',
            current_time: moment(new Date().getTime() - oneDayLong),
            selectedAppcode:'',
            selectedInvokeappcode:'',
            selectedUrl:'',
            appcodes:[],
        };
    },
    methods: {

        handleSearchAppcodeChange(v){
            this.selectedAppcode = v
        },
        handleInvokAppcodeChange(v){
            this.selectedInvokeappcode = v
        },
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        callback(v){
            this.time_type = v;
            if(v == 'perDay'){
                this.current_format = 'HH'
            }
            else if(v == 'perHour'){
                this.current_format = 'HH'
            }
            else if(v == 'perMinute'){
                this.current_format = 'HH:mm'
            }
        },
        handleReset(){

            this.handleSubmit();
        },
        handleSubmit(){
            if(this.appcodes.length == 0){
                this.message.info("抱歉，您没有任何app的授权，请联系架构部授权系统");
                return
            }
            let c_date = new Date(this.current_time).Format("yyyy-MM-dd");
            let c_time = new Date(this.current_time).Format("hh:mm");
            let result_s = "";
            let result_e = "";
            
            switch (this.time_type) {
                case "perDay":
                    result_s = c_date;
                    result_e =  new Date((new Date(result_s)).getTime() + oneDayLong).Format('yyyy-MM-dd');
                    break;
                case "perHour":
                    result_s = c_date + " " + c_time.split(':')[0] + ":00:00";
                    result_e =  new Date((new Date(result_s)).getTime() + oneMinitLong * 60).Format('yyyy-MM-dd hh:mm:ss');
                    break;
                default:
                    break;
            }
            let result = {
                selectedAppcode:this.selectedAppcode,
                selectedInvokeappcode:this.selectedInvokeappcode,
                searchTimeRange:result_s + '~' + result_e,
                timeType:this.time_type,
                servicekey:this.selectedUrl 
            }
            this.$emit("searchChange",result);
        },
        
        handleUrlChange(val){
            this.selectedUrl = val;
        }
       
    },
    props:{
    },
    components:{
        historySelecter:historySelecter,
        AppAutoComplete:AppAutoComplete,
    },
    mounted(){
        this.appcodes = this.G.getAllAppcodes(this);
        this.handleSubmit();
    }
};
</script>
<style scoped>
    .searchBox{
        width: 100%;
        padding-bottom: 20px;
    }
    .searchItem{
        margin-right: 20px;
    }
    .serviceLabel{
        margin-left: 15px;
    }
</style>
